import { render, staticRenderFns } from "./ChatAddUser.vue?vue&type=template&id=5aa004a4&"
import script from "./ChatAddUser.vue?vue&type=script&lang=js&"
export * from "./ChatAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports